module.exports = __webpack_public_path__ + "ad7d61d52aa555a90078cfc5ae45728d.ttf";


//////////////////
// WEBPACK FOOTER
// ./assets/Lato-HairlineItalic.ttf
// module id = 971
// module chunks = 0